// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { GridOffset } from "@insite/mobius/GridContainer";
import { productCarouselProductFullStyles } from "@turnerBlueprint/Overrides/Components/ProductCarouselProductFull";
import { css } from "styled-components";

productCarouselProductFullStyles.container = {
    gap: 0,
    css: css`
        height: 100%;

        ${GridOffset} {
            height: 100%;
        }
    `,
};

productCarouselProductFullStyles.productImageStyles = {
    linkWrappingImage: {
        css: css`
            justify-content: center;
            align-items: center;
            max-height: 317px;
            overflow: hidden;
            object-fit: contain;
        `,
    },
};

productCarouselProductFullStyles.productBrandWrapper = {
    css: css`
        display: flex;
        margin-bottom: 2px;
    `,
};

productCarouselProductFullStyles.availabilityGridItem = {
    width: 12,
    css: css`
        &&& {
            margin-top: 4px;
        }
    `,
};

productCarouselProductFullStyles.quantityOrderedGridItem = {
    width: 5,
};

productCarouselProductFullStyles.addToGridItem = {
    width: 7,
    css: css`
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        gap: 12px;
    `,
};

productCarouselProductFullStyles.productAddToListLinkStyles = {
    link: {
        css: css`
            margin-bottom: 0;
        `,
    },
};

productCarouselProductFullStyles.productPartNumbersStyles = {
    container: {
        css: css`
            margin-bottom: 8px;
        `,
    },
};

productCarouselProductFullStyles.textBadgeGridItem = {
    width: 12,
    css: css`
        &&& {
            gap: 12px;
            margin-bottom: 12px;
            min-height: 24px;
        }
    `,
};

productCarouselProductFullStyles.quantityInfoContainer = {
    width: 12,
    css: css`
        &&& {
            margin: 8px 0;
        }
    `,
};

productCarouselProductFullStyles.productStandardActionsContainer = {
    gap: 6,
};